// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { assoc, compose } from 'lodash/fp';
import { handleActions } from 'redux-actions';
import { closeModal, editForm, openModal } from 'store/actionCreators/modal';
import {
  AddFieldState,
  AddGroupMembersState,
  CreateChatState,
  CreateEventSidebarState,
  EditCommunityEventResponseState,
  EditCommunityEventTypeState,
  EditCommunityTaskState,
  EditUserRoleState,
  EventDetailsSidebarState,
  GiveReplySidebarState,
  InfoPopupV2State,
  PopupMessageState,
  SharePopupState,
  TaskDetailsState,
  ViewMemberState,
} from 'types';

export type ModalState =
  | EventDetailsSidebarState
  | GiveReplySidebarState
  | CreateEventSidebarState
  | EditCommunityEventTypeState
  | EditCommunityEventResponseState
  | EditCommunityTaskState
  | AddGroupMembersState
  | EditUserRoleState
  | AddFieldState
  | SharePopupState
  | PopupMessageState
  | InfoPopupV2State
  | ViewMemberState
  | TaskDetailsState
  | CreateChatState;

const initialState: ModalState = {
  type: null,
  data: null,
  isOpen: false,
  placement: null,
};

export default handleActions<ModalState, any>(
  {
    [openModal.TRIGGER]: (state, { payload }) =>
      compose(
        assoc(['isOpen'], true),
        assoc(['data'], payload.data),
        assoc(['placement'], payload.placement),
        assoc(['type'], payload.type),
      )(state),
    [closeModal.TRIGGER]: (state) =>
      compose(assoc(['isOpen'], false), assoc(['type'], ''))(state),
    [editForm.TRIGGER]: (state, { payload }) =>
      compose(assoc(['edit'], payload))(state),
  },
  initialState,
);
